import getReimbursedFlow from "./getReimbursedFlow"

export const reimbursementWorkflow = [
  {
    name: "Primary Workflow",
    workflow: getReimbursedFlow
  }
]
